export {default as EventCard} from "./EventCard";